export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_SOBRIETY":
      return [...state, action.payload.sobriety];
    case "UPDATE_SOBRIETIES":
      return action.payload.sobrieties;
    case "DELETE_SOBRIETY":
      return state.filter((sobriety) => {
        return sobriety.id !== action.payload.sobriety.id
      });
    default:
      return state;
  }
}
